export const Advertisements = {
  Name: "Оголошення",
  Emoji: "📢",
  Button: {
    ADD: "Додати оголошення",
    DELETE: "Видалити",
  },
  Empty: "Оголошень ще немає",
  Add: {
    TITLE: "Нове оголошення",
    EMOJI: "📢",
    Image: {
      MODAL_TITLE: "Завантажте зображення",
      LABEL: "Зображення",
      SELECT: "Вибрати",
      UPLOAD: "Завантажити",
      CHANGE: "Змінити зображення",
    },
    Url: {
      LABEL: "Посилання (необов'язково)",
      PLACEHOLDER: "https://...",
    },
    TargetRole: {
      LABEL: "Кому показувати",
      ALL: "Всім",
      TEACHER: "Тільки вчителям",
      STUDENT: "Тільки учням",
    },
  },
  Delete: {
    TITLE: "Видалити оголошення?",
    EMOJI: "🗑️",
    Notification: {
      SUCCESS: "Оголошення видалено",
      ERROR: "Не вдалось видалити оголошення",
    },
  },
  Notification: {
    Add: {
      SUCCESS: "Оголошення додано",
      ERROR: "Не вдалось додати оголошення",
    },
  },
};
